import {AIProvider, AIProviderSettings} from "../AIProvider";
import {CommonSettings} from "../common/CommonSettings";

export const OllamaSettings = (props: {
    provider: AIProvider,
    settings: AIProviderSettings,
    onChange: (settings: AIProviderSettings) => void
}) => {
    return (
        <CommonSettings provider={props.provider} settings={props.settings} onChange={props.onChange}/>
    )
}